import serviceRequestAllReducer from './service-request-all.reducers'

export default serviceRequestAllReducer

